import { createContext } from "react";

const MemberInformationContext = createContext();

export default MemberInformationContext;
